// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import ldconfEntity from './entities/ldconf.json';
import ldconfMenu from '../pages/ldconf/menu.json';
import ldconfFullForm from '../pages/ldconf/forms/full.json';
import ldconfContextForm from '../pages/ldconf/forms/context.json';
import ldconfMiniForm from '../pages/ldconf/forms/mini.json';
import ldconfLookupForm from '../pages/ldconf/forms/lookup.json';
import ldconfTableView from '../pages/ldconf/views/table.json';
import ldconfStagesView from '../pages/ldconf/views/stages.json';
import ldconfCardsView from '../pages/ldconf/views/cards.json';
import ldconfInlineView from '../pages/ldconf/views/inline.json';
import ldconfBacklogView from '../pages/ldconf/views/backlog.json';
import ldconfSplitView from '../pages/ldconf/views/split.json';
import ldconfCalendarView from '../pages/ldconf/views/calendar.json';
import ldconfDashboardView from '../pages/ldconf/views/dashboard.json';

/** Тип запису «Колізія» зі сторінками пакета: меню, форми та подання з pages/ldconf/. */
export const ldconfDefinition: IRecordTypeDefinition = {
  ...ldconfEntity,
  views: assembleViewSet({
      table: ldconfTableView,
      stages: ldconfStagesView,
      cards: ldconfCardsView,
      inline: ldconfInlineView,
      backlog: ldconfBacklogView,
      split: ldconfSplitView,
      calendar: ldconfCalendarView,
      dashboard: ldconfDashboardView,
  }),
  form: ldconfFullForm,
  forms: { full: ldconfFullForm, context: ldconfContextForm, mini: ldconfMiniForm, lookup: ldconfLookupForm },
  menu: ldconfMenu,
} as IRecordTypeDefinition;
